import { axios } from '@Root/API'

export const get = (studyProgrammeId, studyLocationId) => {
	return axios.get(`course-session/${studyProgrammeId}/study-location/${studyLocationId}`)
}
